"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var classnames_1 = __importDefault(require("classnames"));
var abstract_input_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/input/abstract_input_store"));
var input_option_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/input/input_option_store"));
var SelectInputStore = /** @class */ (function (_super) {
    __extends(SelectInputStore, _super);
    function SelectInputStore(component, props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (event) {
            _this.value = event.target.value;
        };
        _this.component = component;
        _this.optionStores = props.options.map(function (opt) { return new input_option_store_1.default(opt); });
        return _this;
    }
    Object.defineProperty(SelectInputStore.prototype, "className", {
        get: function () {
            return (0, classnames_1.default)('estimateForm-SingleSelect', {
                'estimateForm-SingleSelect-checked': this.valid
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SelectInputStore.prototype, "valueText", {
        get: function () {
            var _a;
            return ((_a = this.selectedOptionStore) === null || _a === void 0 ? void 0 : _a.label) && String(this.selectedOptionStore.label);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SelectInputStore.prototype, "selectedOptionStore", {
        get: function () {
            var _this = this;
            // 裏から defaultValue が来た時に number で来るが、選択肢の value は string という罠があるので明示的に string にキャストしてます
            return this.optionStores.find(function (option) { return option.value === String(_this.value); });
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], SelectInputStore.prototype, "optionStores", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], SelectInputStore.prototype, "className", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], SelectInputStore.prototype, "valueText", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], SelectInputStore.prototype, "selectedOptionStore", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SelectInputStore.prototype, "handleChange", void 0);
    return SelectInputStore;
}(abstract_input_store_1.default));
exports.default = SelectInputStore;
